import { OnboardingFlow } from '@mondaygpt/constants'
import { FLOW_CONFIGS, setOnboardingComponent } from 'modules/flows'
import React from 'react'
import { DarkOnboardingFlow } from '../dark'

setOnboardingComponent(DarkOnboardingFlow)

/**
 * Get the flow component for a given flow ID.
 * Falls back to default flow if the flow ID is not found.
 */
export const getFlowComponent = (flowId: OnboardingFlow | undefined): React.ComponentType => {
  const config = flowId ? FLOW_CONFIGS[flowId] : undefined
  return config?.onboarding.component ?? FLOW_CONFIGS[OnboardingFlow.Default].onboarding.component
}
